import script from "./dvhc-huyen.vue?vue&type=script&setup=true&lang=js"
export * from "./dvhc-huyen.vue?vue&type=script&setup=true&lang=js"

import "./dvhc-huyen.vue?vue&type=style&index=0&id=edfe850c&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edfe850c"]])

export default __exports__